module.exports = __webpack_public_path__ + "static/media/back_button.fe745512.svg";